"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeRequest = void 0;
const http_1 = __importDefault(require("http"));
const needle_1 = __importDefault(require("needle"));
const querystring = __importStar(require("querystring"));
const https_1 = __importDefault(require("https"));
const url_1 = require("url");
const emitter_1 = __importDefault(require("./emitter"));
const constants_1 = require("./constants");
const agentOptions = {
    keepAlive: true,
    keepAliveMsecs: 1000,
    maxSockets: 256,
    maxFreeSockets: 256,
    freeSocketTimeout: 60000,
    socketActiveTTL: 1000 * 60 * 10,
    rejectUnauthorized: !global.ignoreUnknownCA,
};
async function makeRequest(payload) {
    var _a, _b;
    const data = JSON.stringify(payload.body);
    const parsedUrl = new url_1.URL(payload.url);
    const agent = parsedUrl.protocol === 'http:' ? new http_1.default.Agent(agentOptions) : new https_1.default.Agent(agentOptions);
    const method = (payload.method || 'get').toLowerCase();
    let { url } = payload;
    if (payload.qs) {
        // Parse the URL and append the search part - this will take care of adding the '/?' part if it's missing
        const urlObject = new url_1.URL(url);
        urlObject.search = querystring.stringify(payload.qs);
        url = urlObject.toString();
        delete payload.qs;
    }
    const options = {
        headers: payload.headers,
        open_timeout: 0,
        response_timeout: payload.timeout,
        read_timeout: payload.timeout,
        family: payload.family,
        json: true,
        compressed: true,
        follow_max: 5,
        rejectUnauthorized: !global.ignoreUnknownCA,
        agent,
    };
    emitter_1.default.apiRequestLog(`=> HTTP ${method === null || method === void 0 ? void 0 : method.toUpperCase()} ${url} ${data !== null && data !== void 0 ? data : ''}`.slice(0, 399));
    let attempts = (_a = payload.attempts) !== null && _a !== void 0 ? _a : constants_1.MAX_RETRY_ATTEMPTS;
    let retryDelay = (_b = payload.retryDelay) !== null && _b !== void 0 ? _b : constants_1.REQUEST_RETRY_DELAY;
    let response, success;
    do {
        try {
            response = await (0, needle_1.default)(method, url, data, options);
            emitter_1.default.apiRequestLog(`<= Response: ${response.statusCode} ${JSON.stringify(response.body)}`.slice(0, 399));
            success = !!(response.statusCode && response.statusCode >= 200 && response.statusCode < 300);
            if (success)
                return { success, response };
            // Try to avoid breaking requests due to temporary network errors
            if (attempts > 1 && response.statusCode && [
                constants_1.ErrorCodes.serviceUnavailable,
                constants_1.ErrorCodes.badGateway,
                constants_1.ErrorCodes.connectionRefused,
                constants_1.ErrorCodes.timeout,
                constants_1.ErrorCodes.dnsNotFound,
            ].includes(response.statusCode)) {
                attempts--;
                await new Promise(resolve => setTimeout(resolve, retryDelay));
            }
            else {
                attempts = 0;
            }
        }
        catch (err) {
            emitter_1.default.apiRequestLog(`Request error --> ${err}`.slice(0, 399));
            throw err;
        }
    } while (attempts > 0);
    if (response)
        return { success, response };
    // Following line should be unreachable
    throw new Error('Unknown network error');
}
exports.makeRequest = makeRequest;
//# sourceMappingURL=needle.js.map